/**
 * Konfigurasi identitas situs untuk SEO (metadata, sitemap, robots, JSON-LD).
 * Ganti NEXT_PUBLIC_SITE_URL di environment produksi ke domain asli Garasin.
 */
export const SITE_URL = (
  process.env.NEXT_PUBLIC_SITE_URL || 'https://garasin.com'
).replace(/\/$/, '');

export const SITE_NAME = 'Garasin';

export const SITE_TAGLINE = 'Garasi Indonesia';

export const SITE_DESCRIPTION =
  'Garasin adalah aplikasi manajemen bengkel untuk mengelola antrian servis, transaksi, penjualan sparepart, pelanggan, dan laporan keuangan bengkel dalam satu sistem.';

/**
 * Kontak & tautan yang dipakai landing page. Semua bisa ditimpa lewat
 * environment saat deploy tanpa mengubah kode.
 */

/** Nomor WhatsApp sales, format internasional tanpa tanda plus. */
export const WA_SALES = process.env.NEXT_PUBLIC_WA_SALES || '6283842112621';

/** Link wa.me lengkap dengan pesan pembuka yang sudah terisi. */
export const WA_LINK = `https://wa.me/${WA_SALES}?text=${encodeURIComponent(
  `Halo ${SITE_NAME}, saya ingin tahu lebih lanjut tentang aplikasi bengkelnya.`,
)}`;

export const EMAIL_SALES = process.env.NEXT_PUBLIC_EMAIL_SALES || 'halo@garasin.com';

export const APP_PLAYSTORE_URL = process.env.NEXT_PUBLIC_APP_PLAYSTORE_URL || '#';

export const APP_APPSTORE_URL = process.env.NEXT_PUBLIC_APP_APPSTORE_URL || '#';

/**
 * Identitas badan usaha untuk halaman legal & kontak.
 *
 * Nilai-nilai ini WAJIB sama persis dengan data yang didaftarkan di payment
 * gateway (iPaymu) — halaman kontak dan footer diperiksa manual oleh reviewer
 * mereka. Default 'ISI_...' sengaja dibuat mencolok supaya ketahuan bila
 * environment produksi belum diisi; jangan diganti jadi contoh yang terlihat
 * masuk akal, karena justru akan lolos tanpa disadari.
 */
export const BUSINESS_LEGAL_NAME =
  process.env.NEXT_PUBLIC_BUSINESS_LEGAL_NAME || 'GARASIN INDONESIA ';

export const BUSINESS_ADDRESS =
  process.env.NEXT_PUBLIC_BUSINESS_ADDRESS || 'JALAN TAMAN TLOGOMULYO NO 3 GANG IV';

export const BUSINESS_CITY = process.env.NEXT_PUBLIC_BUSINESS_CITY || 'SEMARANG';

export const BUSINESS_PROVINCE = process.env.NEXT_PUBLIC_BUSINESS_PROVINCE || 'JAWA TENGAH';

export const BUSINESS_POSTAL_CODE =
  process.env.NEXT_PUBLIC_BUSINESS_POSTAL_CODE || '50195';

/** Nomor telepon usaha untuk ditampilkan, format lokal enak dibaca. */
export const BUSINESS_PHONE = process.env.NEXT_PUBLIC_BUSINESS_PHONE || '+62 878-5704-8457';

/** Versi tanpa spasi/strip untuk atribut href="tel:". */
export const BUSINESS_PHONE_TEL = BUSINESS_PHONE.replace(/[^\d+]/g, '');

export const BUSINESS_EMAIL = process.env.NEXT_PUBLIC_BUSINESS_EMAIL || EMAIL_SALES;

export const BUSINESS_HOURS = 'Senin–Jumat, 09.00–17.00 WIB';

/** Alamat satu baris, dipakai di footer dan JSON-LD. */
export const BUSINESS_ADDRESS_FULL = `${BUSINESS_ADDRESS}, ${BUSINESS_CITY}, ${BUSINESS_PROVINCE} ${BUSINESS_POSTAL_CODE}`;

/** Tanggal berlaku dokumen legal (S&K, privasi, refund). */
export const LEGAL_EFFECTIVE_DATE = '26 Juli 2026';
